export {FullDateLocation} from './full-date-location'

export interface FullDateLocationProps {
  event: wix.events.Event
  showDate: boolean
  showLocation: boolean
  fullLocale: string
}
